import styles from '@styles/components/Configuracion/Novedades/ConfiguracionNovedades.module.css';
import tabScreenStyles from '@styles/components/General/TabScreen.module.css';
import { useState } from 'react';

import ConfiguracionNovedadesDias from './ConfiguracionNovedadesDias';
import ConfiguracionNovedadesLista from "./ConfiguracionNovedadesLista";
import ConfiguracionNovedadesAuditoria from "./ConfiguracionNovedadesAuditoria";
import ConfiguracionNovedadesHorasExtra from "./ConfiguracionNovedadesHorasExtra";

import { ReactComponent as ArrowLeftSVG } from '@assets/SVGs/Configuracion/ArrowLeft.svg';
import { useNavigate } from 'react-router-dom';
import designSystemStyles from '@shared/styles/designSystemStyles'

const ConfiguracionNovedades = ({org}) => {

    const [clickedScreen, setClickedScreen] = useState("Dias")

    const navigate = useNavigate()
    const handleNavigation = (path, state) => {
        navigate(path, { state });
    };

    return (
    <div className={tabScreenStyles['content-block']}>
        <div className={tabScreenStyles['header-container']}>
            <div className={styles['title-container']}>
                <h2 className={styles['title']} style={{marginLeft: '25px'}}>
                    <div className={styles['svg-container']} style={{width: '50px', height: '50px', cursor: 'pointer'}} onClick={() => {handleNavigation(-1)}}>
                        <ArrowLeftSVG/>
                    </div>
                    Configuracion <span style={{color: "#BBBFC8", marginLeft: "10px"}}>Novedades</span>
                </h2>
            </div>
        </div>
        <div className={tabScreenStyles['content-container']}>
            <div className={tabScreenStyles['flaps-container']}>
                    <div className={`${tabScreenStyles['flap']} ${clickedScreen === "Dias" ? tabScreenStyles['clicked'] : ''}`}
                        onClick={() => {
                            setClickedScreen('Dias')
                        }}>
                        Días laborales
                    </div>
                    <div className={`${tabScreenStyles['flap']} ${clickedScreen === "Novedades" ? tabScreenStyles['clicked'] : ''}`}
                        onClick={() => {setClickedScreen('Novedades')}}>
                        Catalogo
                    </div>
                    <div className={`${tabScreenStyles['flap']} ${clickedScreen === "HorasExtra" ? tabScreenStyles['clicked'] : ''}`}
                        onClick={() => {setClickedScreen('HorasExtra')}}>
                        Horas extra
                    </div>
                    <div className={`${tabScreenStyles['flap']} ${clickedScreen === "Auditoria" ? tabScreenStyles['clicked'] : ''}`}
                        onClick={() => {setClickedScreen('Auditoria')}}>
                        Auditoria
                    </div>
            </div>
            <div className={tabScreenStyles['inner-container']} style={{zIndex: 1}}>
                {clickedScreen === "Dias" ? 
                    <ConfiguracionNovedadesDias orgID={org.id} timezone={org.timezone}/>
                : clickedScreen === "Novedades" ? 
                    <ConfiguracionNovedadesLista orgID={org.id}/>
                : clickedScreen === "HorasExtra" ?
                    <ConfiguracionNovedadesHorasExtra 
                        orgID={org.id}
                        paddingLeft={designSystemStyles.paddingLg}
                        paddingRight={designSystemStyles.paddingLg}
                    />
                : clickedScreen === "Auditoria" ?
                    <ConfiguracionNovedadesAuditoria orgID={org.id}/>
                : 
                <div/>}

            </div>
        </div>
    </div>
    );
};

export default ConfiguracionNovedades
